<template>
  <v-card>
    <v-card-title v-if="options.title">
      <span class="headline">{{ options.title }}</span>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <ValidationObserver
        ref="form"
        tag="form"
        @submit.prevent="save"
      >
        <ValidationProvider
            rules="required"
            vid="role"
            :name="$t('fields.role').toLowerCase()"
            v-slot="{ errors }"
        >
          <v-select
            :items="roles"
            multiple
            v-model="form.role"
            item-text="name"
            item-value="name"
            attach
            chips
            :label="$t('fields.role')"
            :error-messages="errors"
          >
          </v-select>
        </ValidationProvider>
        <ValidationProvider
            rules="required"
            vid="name"
            :name="$t('fields.name').toLowerCase()"
            v-slot="{ errors }"
        >
          <v-text-field
            v-model=" form.name"
            :counter="30"
            :label="$t('fields.name')"
            :error-messages="errors"
          ></v-text-field>
        </ValidationProvider>
        <ValidationProvider
            rules="required"
            vid="surname"
            :name="$t('fields.surname').toLowerCase()"
            v-slot="{ errors }"
        >
          <v-text-field
            v-model=" form.surname"
            :counter="30"
            :label="$t('fields.surname')"
            :error-messages="errors"
          ></v-text-field>
        </ValidationProvider>
        <ValidationProvider
            rules="required"
            vid="phone"
            :name="$t('fields.phone').toLowerCase()"
            v-slot="{ errors }"
        >
          <v-text-field
            v-model=" form.phone"
            :counter="15"
            :label="$t('fields.phone')"
            :error-messages="errors"
          ></v-text-field>
      </ValidationProvider>
      <ValidationProvider
            rules="required|email|confirmed:email_confirmation"
            vid="email"
            :name="$t('fields.email').toLowerCase()"
            v-slot="{ errors }"
        >
          <v-text-field
            v-model=" form.email"
            :counter="255"
            :label="$t('fields.email')"
            :error-messages="errors"
          ></v-text-field>
      </ValidationProvider>
      <ValidationProvider
            rules="required|email"
            vid="email_confirmation"
            :name="$t('fields.email_confirmation').toLowerCase()"
            v-slot="{ errors }"
        >
        <v-text-field
          v-model=" form.email_confirmation"
          :counter="255"
          :label="$t('fields.email_confirmation')"
          :error-messages="errors"
        ></v-text-field>
      </ValidationProvider>
      <ValidationProvider
            :rules="passwordRule"
            vid="password"
            :name="$t('fields.password').toLowerCase()"
            v-slot="{ errors }"
        >
        <v-text-field
          v-model=" form.password"
          :type="'password'"
          :label="$t('fields.password')"
          :error-messages="errors"
        ></v-text-field>
      </ValidationProvider>
      <ValidationProvider
            vid="password_confirmation"
            :name="$t('fields.password_confirmation').toLowerCase()"
            v-slot="{ errors }"
      >
        <v-text-field
          v-model=" form.password_confirmation"
          :type="'password'"
          :label="$t('fields.password_confirmation')"
          :error-messages="errors"
        ></v-text-field>
      </ValidationProvider>
    </ValidationObserver>
    </v-card-text>
    <v-card-actions>
      <v-btn @click="save" color="primary">{{ $t('SAVE') }}</v-btn>
      <v-btn @click="cancel">{{ $t('CANCEL') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
  import { mapActions, mapState } from 'vuex';

  import { usersService } from '../../utils/services/users.service';
  import { permissionsService } from '../../utils/services/permissions.service';

  export default {
    name: 'UserModal',
    data() {
      return {
        stored: null,
        roles: [],
        user: {},
        passwordRule: 'required|min:8|confirmed:password_confirmation',
        form: {
          name: null,
          surname: null,
          email: null,
          email_confirmation: null,
          phone: null,
          password: null,
          password_confirmation: null,
          role: [],
        },
        loading: false,
      };
    },
    computed: {
      ...mapState('modal', ['options', 'data']),
    },
    methods: {
      ...mapActions('alert', ['showToast']),
      ...mapActions('modal', ['hideModal', 'loadingModal']),
      async save() {
        const isValid = await this.$refs.form.validate();
        if (isValid) {
            if (this.options.onSave) {
              this.loadingModal(true);
              this.options.onSave(
                this.form,
                this.errors,
              )
              .then(() => {
                  this.loadingModal(false);
              })
              .catch(error => {
                  this.handleError(error, this.errors);
              });
            }
        }
      },
      cancel() {
        this.hideModal({});
      },
      fetchRoles() {
        return permissionsService.getRoles()
        .then(response => {
            this.roles = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        });
      },
      fetchUser(id) {
        return usersService.get(id)
        .then(response => {
            this.user = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        });
      },
    },
    async created() {
      this.loadingModal(true);
      await this.fetchRoles();
      if (this.data.stored.id) {
        this.passwordRule = 'min:8|confirmed:password_confirmation';
        await this.fetchUser(this.data.stored.id);

        this.form = {
          id: this.data.stored.id,
          name: this.user.name,
          surname: this.user.surname,
          phone: this.user.phone,
          email: this.user.email,
          email_confirmation: this.user.email,
          role: this.user.roles,
        };
      }
      this.loadingModal(false);
    },
  };
</script>
